import classNames from 'classnames';
import PropTypes from 'prop-types';
import SimpleTooltip from 'react-simple-tooltip';
import IconHelper from '../../../common/components/infoLabel/iconHelper';

const DashboardInfoLabel = ({
  id,
  label,
  showIcon,
  iconType,
  iconColor,
  iconStyles,
  iconLocation,
  onClick,
  toolTipText,
  placement,
}) => {
  const MyTooltip = (
    <SimpleTooltip
      content={<p className="ttp-text">{toolTipText}</p>}
      placement={placement}
      arrow={8}
      background="#f7efd8"
      border="#f7efd8"
      color="#000"
      fontSize="11px"
      padding={5}
      radius={5}
    >
      <IconHelper
        iconType={iconType}
        iconColor={iconColor}
        className={classNames('icon-style', { ...iconStyles })}
        toolTipId={id}
      />
    </SimpleTooltip>
  );

  return (
    <div className="info-label-section" onClick={onClick}>
      {showIcon && iconLocation === 'Left' && MyTooltip}
      <span> {label}</span>
      {showIcon && iconLocation === 'Right' && MyTooltip}
    </div>
  );
};

DashboardInfoLabel.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
  iconType: PropTypes.string,
  iconColor: PropTypes.string,
  iconStyles: PropTypes.shape({}),
  iconLocation: PropTypes.string,
  onClick: PropTypes.func,
  toolTipText: PropTypes.string,
  placement: PropTypes.string,
};

DashboardInfoLabel.defaultProps = {
  id: 'showToolTip',
  label: '',
  showIcon: false,
  iconType: 'FaInfoCircle',
  iconColor: '#B4B1B1',
  iconStyles: {},
  iconLocation: 'Right',
  onClick: () => {},
  toolTipText: '',
  placement: 'bottom',
};

export default DashboardInfoLabel;
